/**
 * 存储方法 sessionStorage   localStorage
 * 
 */
export const Storage = {
  s: {
    set: function (key, val, isObject = false) {
      isObject ? sessionStorage.setItem(key, JSON.stringify(val)) : sessionStorage.setItem(key, val)
    },
    get: function (key, isReturnObject = false) {
      let val = sessionStorage.getItem(key)
      if (val) {
        try {
          return isReturnObject ? JSON.parse(sessionStorage.getItem(key)) : sessionStorage.getItem(key)
        } catch (e) {
          return null
        }
      } else {
        return null
      }
    },
    remove: function (key) {
      if (!sessionStorage[key]) return false
      sessionStorage.removeItem(key)
      return true
    },
    clear: function () {
      sessionStorage.clear()
    }
  },
  l: {
    set: function (key, val, isObject = false) {
      isObject ? localStorage.setItem(key, JSON.stringify(val)) : localStorage.setItem(key, val)
    },
    get: function (key, isReturnObject = false) {
      let val = localStorage.getItem(key)
      if (val) {
        try {
          return isReturnObject ? JSON.parse(localStorage.getItem(key)) : localStorage.getItem(key)
        } catch (e) {
          return null
        }
      } else {
        return null
      }
    },
    remove: function (key) {
      if (!localStorage[key]) return false
      localStorage.removeItem(key)
      return true
    },
    clear: function () {
      localStorage.clear()
    }
  }
}
